import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getRecentArticles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function LatestArticles() {
  const { t } = useTranslation();
  const recentArticles = getRecentArticles(6);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              {t('latestArticles')}
            </h2>
            <p className="text-sm text-foreground-500">持续更新，不错过任何精彩内容</p>
          </div>
          <Link
            to="/category/platform-news"
            className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            {t('viewAll')}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="space-y-4">
          {recentArticles.map((article) => (
            <ArticleCard key={article.id} article={article} variant="horizontal" />
          ))}
        </div>
      </div>
    </section>
  );
}